module.exports = __webpack_public_path__ + "img/icon-delete.ba6dfc1c.svg";